import { AnalyticsProps } from '../../InternalLibrary/analytics';
import {
  default as FieldGroup,
  FieldGroupProps,
} from 'components/atoms/FieldGroup/FieldGroup';
import { default as Select, SelectProps } from 'components/atoms/Select/Select';
import { useCallback } from 'react';
import { useFormik } from 'formik';
import { useValidationText } from 'hooks/useValidationText';
import useEventCollector from '../../hooks/eventCollector/useEventCollector';

export interface SelectActorProps extends AnalyticsProps {
  className?: string;
  formik: ReturnType<typeof useFormik<any>>;
  name: string;
  label: string;
  fieldGroupProps?: Omit<FieldGroupProps, 'children'>;
  selectProps?: Partial<SelectProps>;
}

export const SelectActor: React.FC<SelectActorProps> = ({
  className,
  formik,
  name,
  label,
  fieldGroupProps = {},
  selectProps = {},
}) => {
  const { track } = useEventCollector();

  const onChange = useCallback(
    (e: any) => {
      formik.status?.errors?.[name] && delete formik.status.errors[name];
      formik.handleChange(e);
    },
    [formik, name, track],
  );

  return (
    <FieldGroup
      className={className}
      validationText={useValidationText(formik, name)}
      {...fieldGroupProps}
    >
      <Select
        {...selectProps}
        dataTest={`select-${name}`}
        label={label}
        name={name}
        onChange={onChange}
        onBlur={formik.handleBlur}
        value={formik.values[name]}
      />
    </FieldGroup>
  );
};
